module.exports = __webpack_public_path__ + "img/card_img_bauingenieurwesen.67e29461.png";